import { NgTemplateOutlet } from '@angular/common';
import {
  AfterViewInit,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { SwiperContainer } from 'swiper/element/bundle';
import { SwiperOptions } from 'swiper/types/swiper-options';

export interface NavigationEvent {
  initialized?: boolean;
  isBeginning: boolean;
  isEnd: boolean;
}

@Component({
  selector: 'app-common-swiper',
  standalone: true,
  imports: [NgTemplateOutlet],
  templateUrl: './common-swiper.component.html',
  styleUrl: './common-swiper.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CommonSwiperComponent implements AfterViewInit {
  @Input() slides: any[] = [];
  @Input() swiperContainerId = '';
  @Input() swiperOptions: SwiperOptions = {
    spaceBetween: 10,
    speed: 500,
  };
  @Output() navigationEvent: EventEmitter<NavigationEvent> = new EventEmitter<NavigationEvent>();

  @ViewChild('swiperContainer', { static: true }) swiperContainer!: ElementRef<SwiperContainer>;

  ngAfterViewInit() {
    this.initializeSwiper();
  }

  private initializeSwiper() {
    const swiperElement = this.swiperContainer.nativeElement;
    swiperElement.initialize(); // Manually initialize Swiper with the config

    const swiper = this.swiperContainer.nativeElement.swiper;
    if (swiperElement) {
      Object.assign(swiper.params, this.swiperOptions);
      swiperElement.initialize(); // Reinitialize swiper to apply new config
    }

    setTimeout(() => {
      this.navigationEvent.emit({ isBeginning: swiper.isBeginning, isEnd: swiper.isEnd });
    });
  }

  changeSlide(prevOrNext: number): void {
    const swiper = this.swiperContainer.nativeElement?.swiper;
    if (swiper) {
      setTimeout(() => {
        this.navigationEvent.emit({ isBeginning: swiper.isBeginning, isEnd: swiper.isEnd });
      });
      prevOrNext === -1 ? swiper.slidePrev() : swiper.slideNext();
    }
  }
}
